import { KpiCard } from '../c360';

/**
 * FAZ 6 — Üst şerit: SAYILABİLİR SORUNLAR (spec §6.1).
 *
 * ══ HER KART BİR FİLTRE KISAYOLUDUR ═══════════════════════════════════════════════════════════
 * Kartlar bilgi panosu değil, İŞ KUYRUĞUDUR. "3 servis hatası var" demek yetmez — kullanıcı o üçünü
 * GÖRMEK ister. Tıklayınca grid o üçe filtrelenir; tekrar tıklayınca filtre kalkar.
 *
 * ══ SOLDAN SAĞA ACİLİYET AZALIR ═══════════════════════════════════════════════════════════════
 *   SOLDAKİ ÜÇ KUTU BİZDE:          KUYRUKTA · SERVİS HATASI · ZARF HATALI
 *   SAĞDAKİ İKİ KUTU KARŞI TARAFTA: YANIT BEKLEYEN · SÜRE DOLMAK ÜZERE
 *
 * ══ 2. VE 3. KUTU BİLİNÇLİ OLARAK AYRI ════════════════════════════════════════════════════════
 * İkisi de "gönderilemedi" gibi görünür ama:
 *   SERVİS HATASI → entegratöre ULAŞAMADIK. Belge kusursuz olabilir. `Tekrar Gönder` ÇÖZER.
 *   ZARF HATALI   → ulaştık, GİB belgeyi REDDETTİ. `Tekrar Gönder` AYNI HATAYI VERİR — MUHASEBE düzeltmeli.
 * Tek bir "hatalı" kutusunda birleştirmek, kullanıcıya KİMİ ARAYACAĞINI söylemezdi (spec §2).
 */
export function EDocumentKpiStrip({ summary, activeFilter, onSelect }) {
  const s = summary || {};

  const cards = [
    {
      key: 'queued',
      label: 'Kuyrukta',
      value: s.queued ?? 0,
      hint: 'Henüz gönderilmedi',
      tone: 'warn',
      title: 'Gönderim kuyruğunda bekleyen belgeler',
    },
    {
      key: 'transmissionFailed',
      label: 'Servis Hatası',
      value: s.transmissionFailed ?? 0,
      // Aksiyonu SÖYLÜYORUZ: bu kutu BİT'in kutusudur ve tekrar denemek işe yarar.
      hint: 'Tekrar denenebilir',
      tone: 'crit',
      title: 'Entegratöre ulaşılamadı — bağlantı/timeout. Tekrar gönderim çözebilir.',
    },
    {
      key: 'envelopeError',
      label: 'Zarf Hatalı',
      value: s.envelopeError ?? 0,
      // Aksiyonu SÖYLÜYORUZ: bu kutu MUHASEBENİN kutusudur ve tekrar denemek İŞE YARAMAZ.
      hint: 'Belge düzeltilmeli',
      tone: 'crit',
      title: 'GİB belgeyi reddetti (eksik VKN / yanlış referans). Belge düzeltilmeden tekrar gönderim aynı hatayı verir.',
    },
    {
      key: 'awaitingResponse',
      label: 'Yanıt Bekleyen',
      value: s.awaitingResponse ?? 0,
      // Temel senaryo ve e-Arşiv burada SAYILMAZ — onlarda yanıt DİYE BİR ŞEY YOK (iş kuralı 4).
      hint: 'Ticari e-Fatura / e-İrsaliye',
      tone: 'warn',
      title: 'Karşı tarafın uygulama yanıtı bekleniyor. Aksiyon bizde değil.',
    },
    {
      key: 'deadlineSoon',
      label: 'Süre Dolmak Üzere',
      value: s.deadlineSoon ?? 0,
      hint: '≤ 3 gün kaldı',
      tone: 'warn',
      title: '8 günlük yanıt süresi dolmak üzere. Süre dolarsa fatura otomatik kabul edilmiş sayılır.',
    },
  ];

  return (
    <div className="c360-kpi-grid" style={{ marginBottom: 12 }}>
      {cards.map((c) => (
        <KpiCard
          key={c.key}
          label={c.label}
          value={c.value}
          hint={c.hint}
          tone={c.tone}
          title={c.title}
          active={activeFilter === c.key}
          // Aynı karta tekrar basmak filtreyi KALDIRIR — kullanıcı "geri" düğmesi aramak zorunda kalmasın.
          onClick={() => onSelect(activeFilter === c.key ? null : c.key)}
        />
      ))}
    </div>
  );
}

export default EDocumentKpiStrip;
